import { EmailDraftContent, Form, sanitizeHtml } from "@qw/ui";
import { type FC, useMemo, useState } from "react";

import { useDraft } from "../../providers/draft-provider";
import { DraftEditorReferenceMessage } from "./draft-editor-reference-message";

interface DraftFormValues {
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
}

export const DraftContentForm: FC = () => {
  const { draft } = useDraft();
  const [isReferenceMessageOpen, setIsReferenceMessageOpen] = useState(false);

  const defaultValues: DraftFormValues = useMemo(
    () => ({
      to: draft?.to || [],
      cc: draft?.cc || [],
      bcc: draft?.bcc || [],
      subject: draft?.subject || "",
    }),
    [draft]
  );

  if (!draft) {
    return null;
  }

  return (
    <Form defaultValues={defaultValues} className="flex-1 flex flex-col min-h-0">
      <EmailDraftContent
        initialContent={draft.html ? sanitizeHtml(draft.html) : (draft.text ?? "")}
        afterBody={
          draft.referenceMessageId && (
            <DraftEditorReferenceMessage open={isReferenceMessageOpen} onOpenChange={setIsReferenceMessageOpen} />
          )
        }
        afterBodyExpanded={isReferenceMessageOpen}
      />
    </Form>
  );
};
